import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Music } from 'lucide-react';

const ArtistCard = ({ artist, size = 'normal' }) => {
  return (
    <Link to={`/artist/${artist.id}`}>
      <motion.div
        whileHover={{ scale: 1.02 }}
        className={`group relative rounded-sm overflow-hidden bg-card border border-border card-hover ${
          size === 'hero' ? 'col-span-full md:col-span-8 row-span-2' : ''
        }`}
        data-testid={`artist-card-${artist.id}`}
      >
        <div className={`relative ${size === 'hero' ? 'aspect-[21/9]' : 'aspect-square'}`}>
          <img
            src={artist.image_url || 'https://images.unsplash.com/photo-1614613535308-eb5fbd3d2c17?w=800'}
            alt={artist.name}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://images.unsplash.com/photo-1614613535308-eb5fbd3d2c17?w=800';
            }}
          />
          
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
          
          {/* Content */}
          <div className="absolute bottom-0 left-0 right-0 p-6">
            {size === 'hero' && (
              <p className="text-xs text-secondary tracking-widest uppercase mb-2">Featured Artist</p>
            )}
            <h2 className={`font-heading font-bold tracking-tight ${
              size === 'hero' ? 'text-4xl md:text-5xl lg:text-6xl' : 'text-xl'
            }`}>
              {artist.name}
            </h2>
            {artist.genre && (
              <div className="flex items-center gap-2 mt-2 text-muted-foreground">
                <Music size={14} />
                <span className="text-sm">{artist.genre}</span>
              </div>
            )}
            {size === 'hero' && artist.bio && (
              <p className="text-muted-foreground mt-3 line-clamp-2 max-w-2xl">{artist.bio}</p>
            )}
          </div>

          {/* Hover effect */}
          <div className="absolute inset-0 border-2 border-primary opacity-0 group-hover:opacity-100 transition-opacity rounded-sm" />
        </div>
      </motion.div>
    </Link>
  );
};

export default ArtistCard;
